import FeatureGrid from "@/components/sections/FeatureGrid";
import LifecycleStepper from "@/components/sections/LifecycleStepper";
import Reporting from "@/components/sections/Reporting";
import Customization from "@/components/sections/Customization";
import FieldApp from "@/components/sections/FieldApp";
import Integrations from "@/components/sections/Integrations";
import Security from "@/components/sections/Security";
import DashboardMockup from "@/components/mockups/DashboardMockup";
import { Link } from "react-router-dom";

export default function Product() {
  return (
    <>
      <section className="relative pt-12 pb-20 overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-25 pointer-events-none" />
        <div className="container-x relative">
          <div className="max-w-3xl reveal">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Product</div>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
              One platform. Every ticket. Every market.
            </h1>
            <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
              The full LocateOS workspace: intake, dispatch, the mobile field app, QA, closeouts, billing, and reporting — designed for utility locate operations.
            </p>
            <div className="mt-7 flex gap-3">
              <Link to="/demo" className="bg-[#F97316] hover:bg-[#ea580c] text-white font-semibold px-6 py-3 rounded-lg shadow-[0_8px_24px_rgba(249,115,22,0.4)]">
                Request a Demo
              </Link>
              <Link to="/ai" className="border border-white/15 hover:border-white/30 text-white font-semibold px-6 py-3 rounded-lg">
                See AI in action
              </Link>
            </div>
          </div>
          <div className="reveal mt-12 animate-float-slow">
            <DashboardMockup />
          </div>
        </div>
      </section>

      <LifecycleStepper />
      <FeatureGrid />
      <Reporting />
      <Customization />
      <FieldApp />
      <Integrations />
      <Security />
    </>
  );
}
